import UIDs from "../../../UIDs";

const uid = UIDs.layouts.admin;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    LOGOUT: `${uid}.logout`,
    TRY_LOAD_SESSION: `${uid}.tryLoadSession`,
    SELECT_SCHOOL: `${uid}.selectSchool`,
    
    // Message and request counts
    GET_MESSAGE_REQUEST_COUNTS_ASYNC: `${uid}.getMessageRequestCountsAsync`,
    GET_MESSAGE_REQUEST_COUNTS_SUCCESS: `${uid}.getMessageRequestCountsSuccess`,
    GET_MESSAGE_REQUEST_COUNTS_FAILURE: `${uid}.getMessageRequestCountsFailure`,
    
    // Messages and announcements 
    GET_MESSAGES_AND_ANNOUNCEMENTS_ASYNC: `${uid}.getMessagesAndAnnouncementsAsync`,
    GET_MESSAGES_AND_ANNOUNCEMENTS_SUCCESS: `${uid}.getMessagesAndAnnouncementsSuccess`,
    GET_MESSAGES_AND_ANNOUNCEMENTS_FAILURE: `${uid}.getMessagesAndAnnouncementsFailure`,
    
    // Pending requests
    GET_PENDING_REQUESTS_ASYNC: `${uid}.getPendingRequestsAsync`,
    GET_PENDING_REQUESTS_SUCCESS: `${uid}.getPendingRequestsSuccess`,
    GET_PENDING_REQUESTS_FAILURE: `${uid}.getPendingRequestsFailure`,
    CONFIRM_REQUEST_ASYNC: `${uid}.confirmRequestAsync`,
    CONFIRM_REQUEST_SUCCESS: `${uid}.confirmRequestSuccess`,
    CONFIRM_REQUEST_FAILURE: `${uid}.confirmRequestFailure`,
    DENY_REQUEST_ASYNC: `${uid}.denyRequestAsync`,
    DENY_REQUEST_SUCCESS: `${uid}.denyRequestSuccess`,
    DENY_REQUEST_FAILURE: `${uid}.denyRequestFailure`,
    UPDATE_REQUEST_VIEW_STATUS_ASYNC: `${uid}.updateRequestViewStatusAsync`,
    UPDATE_REQUEST_VIEW_STATUS_SUCCESS: `${uid}.updateRequestViewStatusSuccess`,
    UPDATE_REQUEST_VIEW_STATUS_FAILURE: `${uid}.updateRequestViewStatusFailure`,
    
    // Search
    SEARCH_ANYTHING_ASYNC: `${uid}.searchAnythingAsync`,
    SEARCH_ANYTHING_SUCCESS: `${uid}.searchAnythingSuccess`,
    SEARCH_ANYTHING_FAILURE: `${uid}.searchAnythingFailure`,
};

export { ActionTypes };
